import React from 'react';
import { useTranslation } from 'react-i18next';
import NeuralCanvas from '../NeuralCanvas';
import './InvalidToken.css';

const InvalidToken = () => {
    const { t } = useTranslation();

    return (
        <>
            <div style={{ 
                position: 'fixed', 
                top: 0, 
                left: 0, 
                width: '100%', 
                height: '100%', 
                zIndex: 1 
            }}>
                <NeuralCanvas />
            </div>
            <div className="stars-bg"></div>
            <div className="invalid-token-container">
                <div className="invalid-token-content">
                    <h1>{t('privateForm.error.invalidToken')}</h1>
                    <div className="invalid-token-message">
                        <p>{t('privateForm.error.tokenExpired')}</p>
                        <p className="contact-info">{t('privateForm.error.contactAdmin')}</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InvalidToken; 